import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { GET_POST_ITEMS, CREATE_POST_NEW_RECORD } from "../actions";

import {
  getPostItemSuccess, getPostItemError,
  createNewRecordSuccess,createNewRecordError
} from "./actions";

const GET_NEWS_POST_ERROR = 'Show news items failed.';
const CREATE_NEW_RECORD_ERROR = "New record success.";

const getPostItemAsync = async (postId) => {
  try {
    const responseObject = await centralApiAxios.get(`posts/${postId}`);
    return {
        postItem: responseObject.data,
        message: null,
      };
  } catch (err) {
    return {
      message: GET_NEWS_POST_ERROR
    }
  }
}

function* getPostItem({ payload }) {
  try {
    const resultReturned = yield call(getPostItemAsync, payload.postId);
    if (!resultReturned.message) {
   
      yield put(getPostItemSuccess(resultReturned.postItem));
    } else {
      yield put(getPostItemError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(getPostItemError(GET_NEWS_POST_ERROR));
  }
}

const createNewRecordAsync = async (newRecord) => {
  // const postUpdateRequest = {};
  const responseObject = await centralApiAxios.put("posts?id=" + newRecord.postId, newRecord);

  return {
    postItem: responseObject.data,
    postId: responseObject.data.postId,
    message: ""
  };  
};

function* createNewRecord({ payload }) {
  try {
    const resultReturned = yield call(createNewRecordAsync, payload.postItem);
    if (!resultReturned.message) {
      yield put(createNewRecordSuccess(resultReturned));
      window.location.reload();
    } else {
      yield put(createNewRecordError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(createNewRecordError(CREATE_NEW_RECORD_ERROR));
  }
}

export function* watchCreateNewRecord() {
  yield takeEvery(CREATE_POST_NEW_RECORD, createNewRecord);
}

export function* watchGetPostItem() {
  yield takeEvery(GET_POST_ITEMS, getPostItem);
}

export default function* rootSaga() {
  yield all([
    fork(watchGetPostItem),
    fork(watchCreateNewRecord)
  ]);
}
